import { trimTrailingZeros } from '@/utils/format/trimTrailingZeros'

import {
  formatPriceCuts,
  PRICE_ISSUE_REASON_LABELS,
} from '../../lib/stockImportsPriceLabels'
import type { StockImportsTableColumn } from '../../StockImportsVirtualTable/StockImportsVirtualTable'
import type { PreviewRowDto } from '../../types/stockImports.types'
import { previewColumns } from './previewColumns'

const formatPrice = (value: number | undefined) =>
  value === undefined ? '—' : trimTrailingZeros(value)

const getPriceProblem = (row: PreviewRowDto) =>
  [
    row.prices?.issue ? PRICE_ISSUE_REASON_LABELS[row.prices.issue] : '',
    formatPriceCuts(row.prices?.cuts),
  ]
    .filter(Boolean)
    .join('; ')

const previewPriceColumns: StockImportsTableColumn<PreviewRowDto>[] = [
  {
    id: 'purchasePrice',
    header: 'Закупка',
    width: 'minmax(80px, 0.6fr)',
    cell: ({ row }) => formatPrice(row.original.prices?.purchasePrice),
  },
  {
    id: 'retailPrice',
    header: 'РРЦ',
    width: 'minmax(80px, 0.6fr)',
    cell: ({ row }) => formatPrice(row.original.prices?.retailPrice),
  },
  {
    id: 'segmentPrices',
    header: 'Цены сегментов',
    width: 'minmax(180px, 1.4fr)',
    cell: ({ row }) =>
      (row.original.prices?.segmentPrices ?? []).map((segmentPrice) => (
        <div key={segmentPrice.segmentCode}>
          {segmentPrice.segmentDescription}:{' '}
          {trimTrailingZeros(segmentPrice.price)}
        </div>
      )),
  },
  {
    id: 'priceProblem',
    header: 'Проблема цены',
    width: 'minmax(180px, 1.4fr)',
    cell: ({ row }) => getPriceProblem(row.original),
  },
]

export const previewColumnsWithPrices = [
  ...previewColumns,
  ...previewPriceColumns,
]
